import { mToken } from '@/utils/mToken'

var token = new mToken("mTokenPlugin");

function addOption(optionStr, selectID, flag)
{
    if(flag == 1)
    {
        for(var i = 0; i < optionStr.length; ++i)
            selectID.options.add(new Option(optionStr[i], i));
    }
    if(flag == 2)
    {
        for(var i = 0; i < optionStr.length; ++i)
        {
            selectID.options.add(new Option(optionStr[i][1], i));
        }
    }
}

//枚举当前设备
export function enumDevice()
{
    let ret = token.SOF_LoadLibrary(token.GM3000);

    console.log(ret)
    console.log(token)
    if(ret != 0)
    {
        alert("加载控件失败,请前往首页下载ukey中间件");
        return ;
    }


    return token.SOF_EnumDevice();

}
